import React from "react";
import CreonSurvey from "./fusion";
import CREON_CONTENT_UA from "./creonContentUa";

export const CREON_UA_IMAGE_URLS = {
  current: "https://ai.surveyneuro.com/images/10.png",
  shelfA: "https://ai.surveyneuro.com/images/6.png",
  packA: "https://ai.surveyneuro.com/images/8.png",
  shelfB: "https://ai.surveyneuro.com/images/7.png",
  packB: "https://ai.surveyneuro.com/images/9.png",
};

export const CREON_UA_COMPLETION_URLS = {
  completed: "https://discovery-survey.com/index.php/315679?newtest=Y&lang=uk&315679X11957X427217=1&315679X11957X427222=3&315679X11958X427221={QueryID}",
  screened_out: "https://discovery-survey.com/index.php/315679?newtest=Y&lang=uk&315679X11957X427217=2&315679X11957X427222=3&315679X11958X427221={QueryID}",
  quota_full: "https://discovery-survey.com/index.php/315679?newtest=Y&lang=uk&315679X11957X427217=2&315679X11957X427222=3&315679X11958X427221={QueryID}",
  bad_quality: "https://discovery-survey.com/index.php/315679?newtest=Y&lang=uk&315679X11957X427217=3&315679X11957X427222=3&315679X11958X427221={QueryID}",
};

export default function FusionConsumerUkraineSurvey(props) {
  return (
    <CreonSurvey
      {...props}
      projectId="creon_consumers_ua"
      segment="consumer"
      questionnaireContent={CREON_CONTENT_UA}
      imageUrls={CREON_UA_IMAGE_URLS}
      completionUrls={CREON_UA_COMPLETION_URLS}
      languages={["ua"]}
      defaultLanguage="ua"
      initialLanguage="ua"
    />
  );
}
